// eventbus.js
import Vue from 'vue'
const eventBus = new Vue()
export default eventBus

const SAMPLE_PRINTED = 'SAMPLE_PRINTED'
const SAMPLES_SELECTED = 'SAMPLES_SELECTED'
const DOCUMENT_INFO = 'DOCUMENT_INFO'
const DOCUMENT_FINISH_UPLOAD = 'DOCUMENT_FINISH_UPLOAD'
const DASHBOARD_FAST_LINKS = 'DASHBOARD_FAST_LINKS'
const uploadCompleted = 'uploadCompleted'

export {
  eventBus,
  SAMPLE_PRINTED,
  SAMPLES_SELECTED,
  DOCUMENT_INFO,
  DOCUMENT_FINISH_UPLOAD,
  DASHBOARD_FAST_LINKS,
  uploadCompleted
}
